import type { IntlShape } from 'react-intl'
import { setLocale } from 'yup'

import { createYupLocale } from './createYupLocale'

/**
 * Yup captures a schema's message when the schema is constructed, so this must run before
 * anything builds a schema — for the provider, during render and ahead of its descendants.
 *
 * Writing Yup's global is idempotent, so repeat calls are harmless.
 */
export const registerYupLocale = (formatMessage: IntlShape['formatMessage']) =>
  setLocale(createYupLocale(formatMessage))
